import { theme } from "../../../../src/@rocketseat/gatsby-theme-docs/styles/theme";
import * as React from 'react';
export default {
  theme,
  React
};